import React from 'react';

export default function Modal({
  open, onClose, title, children, actions, width = '500px',
}) {
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'var(--color-overlay)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        padding: 'var(--sp-lg)',
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'var(--color-white)',
          borderRadius: 'var(--radius-lg)',
          padding: 'var(--sp-2xl)',
          width: '100%',
          maxWidth: width,
          maxHeight: '90vh',
          overflowY: 'auto',
          boxShadow: 'var(--shadow-xl)',
          position: 'relative',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 'var(--sp-xl)',
        }}>
          <h3 style={{
            margin: 0,
            fontSize: 'var(--font-size-lg)',
            color: 'var(--color-primary)',
          }}>{title}</h3>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '22px',
              cursor: 'pointer',
              color: 'var(--color-text-light)',
              padding: '4px 8px',
              borderRadius: '4px',
            }}
          >
            ✕
          </button>
        </div>
        <div>{children}</div>
        {actions && (
          <div style={{
            display: 'flex',
            gap: 'var(--sp-sm)',
            justifyContent: 'flex-end',
            marginTop: 'var(--sp-xl)',
            borderTop: '1px solid var(--color-border-light)',
            paddingTop: 'var(--sp-lg)',
          }}>
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
